import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function ScrewPitchRow() {
   return (
      <InputRangeRow
         titleProp={"Screw Pitch"}
         descriptionProp={"mm"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={4.0}
         maxProp={20.0}
         propertyNameProp={"screwPitch"}
         errorDialogueProp={"4.0-20.0 only"}
         floatProp={true}
      />
   );
}
